export default __webpack_public_path__ + "static/media/bkg--design-1.e7353207.jpg";